import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ZipcodeState {
    zipcode: string;
    prevZipcode: string;
}

const initialState: ZipcodeState = {
    zipcode: '',
    prevZipcode: '',
};

const zipcodeSlice = createSlice({
    name: 'zipcode',
    initialState,
    reducers: {
        updateZipcode: (state, action: PayloadAction<string>) => {
            state.prevZipcode = state.zipcode;
            state.zipcode = action.payload;
        },
        updatePrevZipcode: (state, action: PayloadAction<string>) => {
            state.prevZipcode = action.payload;
        },
    },
});

export const { updateZipcode, updatePrevZipcode } = zipcodeSlice.actions;

export default zipcodeSlice.reducer;

export const selectZipcode = ({ zipcode }: RootState): string => zipcode.zipcode;
export const selectPrevZipcode = ({ zipcode }: RootState): string => zipcode.prevZipcode;
